export default __webpack_public_path__ + "static/media/speer_logo_footer_white.485c955a.svg";